import { render, staticRenderFns } from "./canEatDetail.vue?vue&type=template&id=386d49e1&scoped=true"
import script from "./canEatDetail.vue?vue&type=script&lang=js"
export * from "./canEatDetail.vue?vue&type=script&lang=js"
import style0 from "./canEatDetail.vue?vue&type=style&index=0&id=386d49e1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386d49e1",
  null
  
)

export default component.exports